export class ToggleSidebar {
  static readonly type = '[UI] Toggle sidebar';
}
